import { ComponentConfig } from '@measured/puck';

import { Text, TextSize, TextWeight } from '../../../../components/atoms/text/text';

type TextBlockProps = {
  text: string | React.ReactNode;
  size?: TextSize;
  weight?: TextWeight;
};

const TextBlock: ComponentConfig<TextBlockProps> = {
  label: 'Text',
  fields: {
    text: {
      type: 'textarea',
    },
    size: {
      type: 'radio',
      options: [
        { label: 'Extra Small', value: 'xs' },
        { label: 'Small', value: 'sm' },
        { label: 'Medium', value: 'md' },
        { label: 'Large', value: 'lg' },
      ],
    },
    weight: {
      type: 'radio',
      options: [
        { label: 'Normal', value: 'normal' },
        { label: 'Semibold', value: 'semibold' },
        { label: 'Bold', value: 'bold' },
      ],
    },
  },
  defaultProps: {
    text: 'This is generic text',
    weight: 'normal',
    size: 'md',
  },
  render: ({ text, weight, size }: TextBlockProps) => {
    return (
      <Text size={size} weight={weight}>
        {text}
      </Text>
    );
  },
};

export { TextBlock };
export type { TextBlockProps };
